import { addDays, daysBetween } from "./day.js";
/**
 * زنجیره با مکانیزم بخشش «شب ابری».
 * قاعده: زنجیره با «روز فعال» زنده می‌ماند — حداقل یک ثبت — نه با «روز کامل».
 * سخت‌گیری بیشتر از این، کاربر را در روز بد فراری می‌دهد.
 */
export const FREEZE_PER_MONTH = { free: 1, plus: 3 };
/**
 * آیا کل فاصلهٔ بین دو روز داخل تعطیلات بوده؟
 * فقط وقتی «بله» است که تمام روزهای نیفتاده پوشش داده شده باشند — وگرنه
 * کاربری که یک روز قبل از سفر غیبت کرده هم بخشیده می‌شود و قاعده بی‌معنا می‌گردد.
 */
function gapCoveredByVacation(from, to, opts) {
    if (!opts?.vacationUntil)
        return false;
    const start = opts.vacationFrom ?? "0000-00-00";
    // روزهای جاافتاده: از روزِ بعد از آخرین فعالیت تا روزِ قبل از فعالیت تازه
    const firstMissed = addDays(from, 1);
    const lastMissed = addDays(to, -1);
    if (firstMissed > lastMissed)
        return true; // چیزی جا نیفتاده
    return firstMissed >= start && lastMissed <= opts.vacationUntil;
}
/**
 * وضعیت زنجیره را با ثبت فعالیت در یک روز به‌روز می‌کند.
 * خالص است: ورودی می‌گیرد، خروجی می‌دهد، چیزی را تغییر نمی‌دهد.
 */
export function applyActivity(progress, activeDay, opts) {
    const { lastActiveDay, currentStreak, longestStreak, freezeTokens } = progress;
    if (!lastActiveDay) {
        return { currentStreak: 1, longestStreak: Math.max(1, longestStreak), freezeTokens, usedFreeze: false };
    }
    const gap = daysBetween(lastActiveDay, activeDay);
    // همان روز — تغییری نمی‌کند
    if (gap <= 0) {
        return { currentStreak, longestStreak, freezeTokens, usedFreeze: false };
    }
    // روز بعد — زنجیره ادامه دارد
    if (gap === 1) {
        const next = currentStreak + 1;
        return { currentStreak: next, longestStreak: Math.max(next, longestStreak), freezeTokens, usedFreeze: false };
    }
    // تعطیلات: روزهای جاافتاده پوشش داده شده‌اند، پس زنجیره ادامه دارد.
    // برخلاف «شب ابری»، زنجیره جلو نمی‌رود — سفر روزِ تلاش حساب نمی‌شود.
    if (gapCoveredByVacation(lastActiveDay, activeDay, opts)) {
        const next = currentStreak + 1;
        return { currentStreak: next, longestStreak: Math.max(next, longestStreak), freezeTokens, usedFreeze: false };
    }
    // دقیقاً یک روز جا افتاده و توکن «شب ابری» داریم
    if (gap === 2 && freezeTokens > 0) {
        const next = currentStreak + 2;
        return {
            currentStreak: next,
            longestStreak: Math.max(next, longestStreak),
            freezeTokens: freezeTokens - 1,
            usedFreeze: true,
        };
    }
    // زنجیره شکست — رکورد قبلی همیشه نمایش داده می‌شود
    return {
        currentStreak: 1,
        longestStreak: Math.max(currentStreak, longestStreak),
        freezeTokens,
        usedFreeze: false,
        brokeFrom: currentStreak > 1 ? currentStreak : undefined,
    };
}
/** آیا زنجیره همین حالا در خطر است؟ (امروز هنوز فعالیتی نبوده) */
export function streakAtRisk(progress, today, opts) {
    if (!progress.lastActiveDay || progress.currentStreak === 0)
        return false;
    if (onVacation(today, opts))
        return false; // در تعطیلات نباید نگرانش کنیم
    return daysBetween(progress.lastActiveDay, today) >= 1;
}
/** آیا این روز داخل حالت تعطیلات است؟ */
export function onVacation(day, opts) {
    if (!opts?.vacationUntil)
        return false;
    return day >= (opts.vacationFrom ?? "0000-00-00") && day <= opts.vacationUntil;
}
/**
 * سقف توکن «شب ابری» برای هر طرح.
 * سرور با همین، عددی که کلاینت فرستاده را می‌بُرد — وگرنه نسخهٔ دست‌کاری‌شده
 * می‌تواند برای خودش توکن بی‌نهایت بسازد.
 */
export function clampFreeze(tokens, plan) {
    return Math.max(0, Math.min(Number(tokens) || 0, FREEZE_PER_MONTH[plan]));
}
/** توکن‌های «شب ابری» را ابتدای هر ماه شمسی پر می‌کند */
export function refillFreeze(progress, monthKey, plan = "free") {
    if (progress.freezeRefilledMonth === monthKey)
        return progress;
    return { ...progress, freezeTokens: FREEZE_PER_MONTH[plan], freezeRefilledMonth: monthKey };
}
/** روزهای پیوستهٔ فعال، برای نمایش تقویم کوچک */
export function streakDays(lastActiveDay, streak) {
    return Array.from({ length: streak }, (_, i) => addDays(lastActiveDay, -(streak - 1 - i)));
}
//# sourceMappingURL=streak.js.map